
      export const versions = {
        commit: 'dc136d255c4775497d5cf58fbfae078f074400c4',
        branch: 'HEAD'
      };
